import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message} from 'semantic-ui-react'
import _ from 'lodash';

import SeguroPermite from '../../../components/funcionales/seguropermite'

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

import queries from '../../../utils/queries'

const DetalleNuminfNivel1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.numeroInflab}</option>
    )
};

const ListaNuminf = ({styles, list, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNuminfNivel1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="numeroInflab" id="miLista" onChange={(ev)=>handleChange(ev)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

const DetallePl = ({elemento}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.mecInflab}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.prioridad?elemento.prioridad:'Normal'}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta?elemento.ruta:0}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroOrden?elemento.numeroOrden:0}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ordenSAP?elemento.ordenSAP:''}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codEquipo}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: elemento.prioridad==='Alta'?'#FFC300':'#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrLubricante}</td>
    </tr>
  )
};

const ListaPl = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const DetallePlDet = ({elemento}) => {
  return(
    <tr className=''>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.mecInflab}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estado}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaMuestra}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tomaMuestra}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ultimoCambio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.recorrido}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cambioFiltroAc}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cambioFiltroAire}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aceiteRep}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aceiteTotal}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.color}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.visco40}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.visco100}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.indice}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.agua}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.codigoPar}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras4}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras6}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras14}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras21}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras25}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras38}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.micras70}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hollin}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nitracion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sulfatacion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.dilucion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.glicol}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.oxidacion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tan}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbn}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.hierro}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cobre}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.aluminio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.cromo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.plomo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.estano}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.niquel}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.vanadio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.titanio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.silicio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.sodio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.potasio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.boro}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.magnesio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.calcio}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fosforo}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.zinc}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.molibdeno}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.bario}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.manganeso}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.color}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerP}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerA}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerF}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rulerZ}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.rpvot}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.barniz}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadA}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadAg}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadE}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.demulsibilidadT}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA54}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg54}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE54}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT54}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaA82}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaAg82}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaE82}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.separaT82}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas1_10}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas2_10}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_0}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.espumas3_10}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.liberacion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.inflamacion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.corrosion}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ultracentrifuga}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.densidad}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.apariencia}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.olor}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fuego}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.pq?elemento.pq:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fischer?elemento.fischer:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tanpte?elemento.tanpte:''}</td>
      <td className='' style={{color: 'black', background: '#ffffff', paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.tbnpte?elemento.tbnpte:''}</td>
    </tr>
  )
};

const ListaPlDet = ({list}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePlDet elemento={elemento} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

class LabCargares2 extends React.Component {
  state={listDocum: [], argsDocum: {numeroInflab: 0}, checked: true, permiteUpdate: true, confirmaAct: false,
      open: false, errors: []}

  crudBD = async (operacionCRUD, args, i)=>{
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        const {data} = await operacionCRUD({
          variables: args
        });
      }
    }
  }

  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChange = (ev) => {
    
    const updState = (listDocum) => {
      this.setState({listDocum, errors: []})
    };

    if(ev.target.name==="numeroInflab"){
      const argsDocum = this.state.argsDocum
      let argsBuscar=""
      // argsBuscar += `'estadoInflab': 'GENERADO', 'numeroInflab': ${ev.target.value}`
      argsBuscar += `'numeroInflab': ${ev.target.value}`

      let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
      this.props.allInflabRtes2.refetch(argsBuscarIl)
  
      argsDocum[ev.target.name] = ev.target.value
      this.setState({argsDocum});
    }

    if(ev.target.name==="csv"||ev.target.name==="checkTieneEncab"){
      let checkTieneEncab = document.getElementById("checkTieneEncab").checked
      let fileInput = document.getElementById("csv")
      if(fileInput.files.length>0){
        document.body.style.cursor = 'wait'

        let archcsv = ""
        let reader = new FileReader();
        reader.onload = function () {
          archcsv = reader.result
          let archivo = archcsv.toString()

          let lines = archivo.split(/\n/)
          let numDoc = 0, linea = 0, listDocum = []
          lines.forEach(line => {
            // console.log(line)
            if(line&&(numDoc>0||(numDoc===0&&!checkTieneEncab))){
              linea += 1
              let campos = line.split(";")
              
              let mecInflab = parseInt(campos[0], 10)
              let ruta = campos[1]
              let numeroOrden = campos[2]
              let ordenSAP=''    
              let numOrdenCompra=''        
              if(campos[3]==null || campos[3]==''){
              }else{
                ordenSAP = campos[3].replace(/^\s+|\s+$/g, '')
              }
              if(campos[4]==null || campos[4]==''){
              }else{
                numOrdenCompra = campos[4].replace(/^\s+|\s+$/g, '')
              }              
              let descrEmpresa = campos[5]
              let descrPlanta = campos[6]
              let descrSeccion = campos[7]
              let descrEquipo = campos[8]
              let codEquipo = campos[9]
              let descrComponente = campos[10]
              let descrMecanismo = campos[11]
              let descrAplicacion = campos[12]

              let estado = campos[13]

              let descrFabricante = campos[14]
              let descrLubricante = campos[15]
              let tipoGrado = campos[16]

              let fechaMuestra = campos[17]
              let campoAgno = ''
              let campoMes = ''
              let campoDia= ''
              if(fechaMuestra){
                campoAgno = fechaMuestra.substring(0, 4)
                campoMes = fechaMuestra.substring(5, 7)
                campoDia = fechaMuestra.substring(8, 10)
                if(campoDia!==null && campoDia!=='' && campoMes!==null && campoMes!=='' && campoAgno!==null && campoAgno!==''){
                  let mes = parseInt(campoMes, 10)
                  if(mes < 10){ 
                    campoMes='0' + mes
                  }else{
                    campoMes = mes
                  }
                  let dia = parseInt(campoDia, 10)
                  if(dia < 10){ 
                    campoDia='0' + dia
                  }else{
                    campoDia = dia
                  }
                  fechaMuestra = campoAgno + '-' + campoMes + '-' + campoDia
                }
              }

              let tomaMuestra = ''
              let ultimoCambio = ''
              
              let tipoFrecuencia = campos[21]
              let recorrido=''
              console.log(tipoFrecuencia)
              if(campos[21]===null || campos[21]===''){
              }else{
                if(campos[18]===null || campos[18]==='' || campos[19]===null || campos[19]===''){
                }else{
                  if(tipoFrecuencia==='Horas' || tipoFrecuencia==='Km'){
                    tomaMuestra = campos[18]
                    ultimoCambio = campos[19]
                    if(parseInt(tomaMuestra) > parseInt(ultimoCambio)){
                      recorrido=parseInt(tomaMuestra) - parseInt(ultimoCambio)
                    }else{recorrido=0}
                  }else{
                    if(tipoFrecuencia==='Calendario'){ 
                      tomaMuestra = campos[18]
                      ultimoCambio = campos[19]


                      let campoAgno = ''
                      let campoMes = ''
                      let campoDia= ''
                      if(tomaMuestra){
                        campoAgno = tomaMuestra.substring(0, 4)
                        campoMes = tomaMuestra.substring(5, 7)
                        campoDia = tomaMuestra.substring(8, 10)
                        if(campoDia!==null && campoDia!=='' && campoMes!==null && campoMes!=='' && campoAgno!==null && campoAgno!==''){
                          let mes = parseInt(campoMes, 10)
                          if(mes < 10){ 
                            campoMes='0' + mes
                          }else{
                            campoMes = mes
                          }
                          let dia = parseInt(campoDia, 10)
                          if(dia < 10){ 
                            campoDia='0' + dia
                          }else{
                            campoDia = dia
                          }
                          tomaMuestra = campoAgno + '-' + campoMes + '-' + campoDia
                        }
                      }

                      campoAgno = ''
                      campoMes = ''
                      campoDia= ''
                      if(ultimoCambio){
                        campoAgno = ultimoCambio.substring(0, 4)
                        campoMes = ultimoCambio.substring(5, 7)
                        campoDia = ultimoCambio.substring(8, 10)
                        if(campoDia!==null && campoDia!=='' && campoMes!==null && campoMes!=='' && campoAgno!==null && campoAgno!==''){
                          let mes = parseInt(campoMes, 10)
                          if(mes < 10){ 
                            campoMes='0' + mes
                          }else{
                            campoMes = mes
                          }
                          let dia = parseInt(campoDia, 10)
                          if(dia < 10){ 
                            campoDia='0' + dia
                          }else{
                            campoDia = dia
                          }
                          ultimoCambio = campoAgno + '-' + campoMes + '-' + campoDia
                        }
                      }
                      
                      if(ultimoCambio && tomaMuestra){
                        let diasdif= new Date(tomaMuestra).getTime()-new Date(ultimoCambio).getTime()
                        let contdias = Math.round(diasdif/(1000*60*60*24))
                        // console.log(tomaMuestra, ultimoCambio, contdias)
                        if(contdias>0){
                          recorrido = contdias
                        }else{recorrido=0}
                      }
                    }                      
                  }
                }
              }

              let cambioFiltroAc = campos[22]
              let cambioFiltroAire = campos[23]
              let aceiteRep=''
              if(campos[24]==null || campos[24]==''){
              }else{
                aceiteRep = campos[24].replace(/\./g,'');
                aceiteRep = aceiteRep.replace(/\,/g,'.');
                aceiteRep = parseFloat(aceiteRep).toFixed(2)
              }  
              let aceiteTotal=''            
              if(campos[25]==null || campos[25]==''){
              }else{
                aceiteTotal = campos[25].replace(/\./g,'');
                aceiteTotal = aceiteTotal.replace(/\,/g,'.');
                aceiteTotal = parseFloat(aceiteTotal).toFixed(2)
              }                        
              let abrevUnidad = campos[26]
              let visco40=''            
              if(campos[27]==null || campos[27]==''){
              }else{
                visco40 = campos[27].replace(/\./g,'');
                visco40 = visco40.replace(/\,/g,'.');
                visco40 = parseFloat(visco40)
              }                        
              let visco100=''            
              if(campos[28]==null || campos[28]==''){
              }else{
                visco100 = campos[28].replace(/\./g,'');
                visco100 = visco100.replace(/\,/g,'.');
                visco100 = parseFloat(visco100)
              }                        
              let indice=''            
              if(campos[29]==null || campos[29]==''){
              }else{
                indice = campos[29].replace(/\./g,'');
                indice = indice.replace(/\,/g,'.');
                indice = parseFloat(indice)
              }
              let agua=''            
              if(campos[30]==null || campos[30]==''){
              }else{
                agua = campos[30].replace(/\./g,'');
                agua = agua.replace(/\,/g,'.');
                agua = parseFloat(agua)
              }   
              let codigoPar=''            
                                    
              let micras4=''            
              if(campos[32]==null || campos[32]==''){
              }else{
                micras4 = campos[32].replace(/\./g,'');
                micras4 = micras4.replace(/\,/g,'.');
                micras4 = parseFloat(micras4)
              }                        
              let micras6=''            
              if(campos[33]==null || campos[33]==''){
              }else{
                micras6 = campos[33].replace(/\./g,'');
                micras6 = micras6.replace(/\,/g,'.');
                micras6 = parseFloat(micras6)
              }                        
              let micras14=''            
              if(campos[34]==null || campos[34]==''){
              }else{
                micras14 = campos[34].replace(/\./g,'');
                micras14 = micras14.replace(/\,/g,'.');
                micras14 = parseFloat(micras14)
              }                
              let micras21=''            
              if(campos[35]==null || campos[35]==''){
              }else{
                micras21 = campos[35].replace(/\./g,'');
                micras21 = micras21.replace(/\,/g,'.');
                micras21 = parseFloat(micras21)
              }                
              let micras25=''            
              if(campos[36]==null || campos[36]==''){
              }else{
                micras25 = campos[36].replace(/\./g,'');
                micras25 = micras25.replace(/\,/g,'.');
                micras25 = parseFloat(micras25)
              }                
              let micras38=''            
              if(campos[37]==null || campos[37]==''){
              }else{
                micras38 = campos[37].replace(/\./g,'');
                micras38 = micras38.replace(/\,/g,'.');
                micras38 = parseFloat(micras38)
              }                
              let micras70=''            
              if(campos[38]==null || campos[38]==''){
              }else{
                micras70 = campos[38].replace(/\./g,'');
                micras70 = micras70.replace(/\,/g,'.');
                micras70 = parseFloat(micras70)
              }                
              let hollin=''            
              if(campos[39]==null || campos[39]==''){
              }else{
                hollin = campos[39].replace(/\./g,'');
                hollin = hollin.replace(/\,/g,'.');
                hollin = parseFloat(hollin)
              }                              
              let nitracion=''            
              if(campos[40]==null || campos[40]==''){
              }else{
                nitracion = campos[40].replace(/\./g,'');
                nitracion = nitracion.replace(/\,/g,'.');
                nitracion = parseFloat(nitracion)
              }                              
              let sulfatacion=''            
              if(campos[41]==null || campos[41]==''){
              }else{
                sulfatacion = campos[41].replace(/\./g,'');
                sulfatacion = sulfatacion.replace(/\,/g,'.');
                sulfatacion = parseFloat(sulfatacion)
              }                              
              let dilucion=''            
              if(campos[42]==null || campos[42]==''){
              }else{
                dilucion = campos[42].replace(/\./g,'');
                dilucion = dilucion.replace(/\,/g,'.');
                dilucion = parseFloat(dilucion)
              }                
              let glicol=''            
              if(campos[43]==null || campos[43]==''){
              }else{
                glicol = campos[43].replace(/\./g,'');
                glicol = glicol.replace(/\,/g,'.');
                glicol = parseFloat(glicol)
              }                
              let oxidacion=''            
              if(campos[44]==null || campos[44]==''){
              }else{
                oxidacion = campos[44].replace(/\./g,'');
                oxidacion = oxidacion.replace(/\,/g,'.');
                oxidacion = parseFloat(oxidacion)
              }                
              let tan=''            
              if(campos[45]==null || campos[45]==''){
              }else{
                tan = campos[45].replace(/\./g,'');
                tan = tan.replace(/\,/g,'.');
                tan = parseFloat(tan)
              }                
              let tbn=''            
              if(campos[46]==null || campos[46]==''){
              }else{
                tbn = campos[46].replace(/\./g,'');
                tbn = tbn.replace(/\,/g,'.');
                tbn = parseFloat(tbn)
              }
              let hierro=''            
              if(campos[47]==null || campos[47]==''){
              }else{
                hierro = campos[47].replace(/\./g,'');
                hierro = hierro.replace(/\,/g,'.');
                hierro = parseFloat(hierro)
              }                
              let cobre=''            
              if(campos[48]==null || campos[48]==''){
              }else{
                cobre = campos[48].replace(/\./g,'');
                cobre = cobre.replace(/\,/g,'.');
                cobre = parseFloat(cobre)
              }                
              let aluminio=''            
              if(campos[49]==null || campos[49]==''){
              }else{
                aluminio = campos[49].replace(/\./g,'');
                aluminio = aluminio.replace(/\,/g,'.');
                aluminio = parseFloat(aluminio)
              }                
              let cromo=''            
              if(campos[50]==null || campos[50]==''){
              }else{
                cromo = campos[50].replace(/\./g,'');
                cromo = cromo.replace(/\,/g,'.');
                cromo = parseFloat(cromo)
              }                
              let plomo=''            
              if(campos[51]==null || campos[51]==''){
              }else{
                plomo = campos[51].replace(/\./g,'');
                plomo = plomo.replace(/\,/g,'.');
                plomo = parseFloat(plomo)
              }                
              let estano=''            
              if(campos[52]==null || campos[52]==''){
              }else{
                estano = campos[52].replace(/\./g,'');
                estano = estano.replace(/\,/g,'.');
                estano = parseFloat(estano)
              }                
              let niquel=''            
              if(campos[53]==null || campos[53]==''){
              }else{
                niquel = campos[53].replace(/\./g,'');
                niquel = niquel.replace(/\,/g,'.');
                niquel = parseFloat(niquel)
              }                
              let vanadio=''            
              if(campos[54]==null || campos[54]==''){
              }else{
                vanadio = campos[54].replace(/\./g,'');
                vanadio = vanadio.replace(/\,/g,'.');
                vanadio = parseFloat(vanadio)
              } 
              let titanio=''            
              if(campos[55]==null || campos[55]==''){
              }else{
                titanio = campos[55].replace(/\./g,'');
                titanio = titanio.replace(/\,/g,'.');
                titanio = parseFloat(titanio)
              } 
              let silicio=''            
              if(campos[56]==null || campos[56]==''){
              }else{
                silicio = campos[56].replace(/\./g,'');
                silicio = silicio.replace(/\,/g,'.');
                silicio = parseFloat(silicio)
              }                              
              let sodio=''            
              if(campos[57]==null || campos[57]==''){
              }else{
                sodio = campos[57].replace(/\./g,'');
                sodio = sodio.replace(/\,/g,'.');
                sodio = parseFloat(sodio)
              }                
              let potasio=''            
              if(campos[58]==null || campos[58]==''){
              }else{
                potasio = campos[58].replace(/\./g,'');
                potasio = potasio.replace(/\,/g,'.');
                potasio = parseFloat(potasio)
              }                
              let boro=''            
              if(campos[59]==null || campos[59]==''){
              }else{
                boro = campos[59].replace(/\./g,'');
                boro = boro.replace(/\,/g,'.');
                boro = parseFloat(boro)
              }                
              let magnesio=''            
              if(campos[60]==null || campos[60]==''){
              }else{
                magnesio = campos[60].replace(/\./g,'');
                magnesio = magnesio.replace(/\,/g,'.');
                magnesio = parseFloat(magnesio)
              }                
              let calcio=''            
              if(campos[61]==null || campos[61]==''){
              }else{
                calcio = campos[61].replace(/\./g,'');
                calcio = calcio.replace(/\,/g,'.');
                calcio = parseFloat(calcio)
              }                
              let fosforo=''            
              if(campos[62]==null || campos[62]==''){
              }else{
                fosforo = campos[62].replace(/\./g,'');
                fosforo = fosforo.replace(/\,/g,'.');
                fosforo = parseFloat(fosforo)
              }                
              let zinc=''            
              if(campos[63]==null || campos[63]==''){
              }else{
                zinc = campos[63].replace(/\./g,'');
                zinc = zinc.replace(/\,/g,'.');
                zinc = parseFloat(zinc)
              }                
              let molibdeno=''            
              if(campos[64]==null || campos[64]==''){
              }else{
                molibdeno = campos[64].replace(/\./g,'');
                molibdeno = molibdeno.replace(/\,/g,'.');
                molibdeno = parseFloat(molibdeno)
              }                
              let bario=''            
              if(campos[65]==null || campos[65]==''){
              }else{
                bario = campos[65].replace(/\./g,'');
                bario = bario.replace(/\,/g,'.');
                bario = parseFloat(bario)
              }                
              let manganeso=''            
              if(campos[66]==null || campos[66]==''){
              }else{
                manganeso = campos[66].replace(/\./g,'');
                manganeso = manganeso.replace(/\,/g,'.');
                manganeso = parseFloat(manganeso)
              }      
              let color=''            
              if(campos[67]==null || campos[67]==''){
              }else{
                color = campos[67].replace(/\./g,'');
                color = color.replace(/\,/g,'.');
                color = parseFloat(color)
              } 
              let rulerP=''     
              if(campos[68]==null || campos[68]==''){
              }else{
                rulerP = campos[68].replace(/\./g,'');
                rulerP = rulerP.replace(/\,/g,'.');
                rulerP = parseFloat(rulerP)
              } 
              let rulerA=''     
              if(campos[69]==null || campos[69]==''){
              }else{
                rulerA = campos[69].replace(/\./g,'');
                rulerA = rulerA.replace(/\,/g,'.');
                rulerA = parseFloat(rulerA)
              } 
              let rulerF=''     
              if(campos[70]==null || campos[70]==''){
              }else{
                rulerF = campos[70].replace(/\./g,'');
                rulerF = rulerF.replace(/\,/g,'.');
                rulerF = parseFloat(rulerF)
              } 
              let rulerZ=''     
              if(campos[71]==null || campos[71]==''){
              }else{
                rulerZ = campos[71].replace(/\./g,'');
                rulerZ = rulerZ.replace(/\,/g,'.');
                rulerZ = parseFloat(rulerZ)
              } 
              let rpvot=''     
              if(campos[72]==null || campos[72]==''){
              }else{
                rpvot = campos[72].replace(/\./g,'');
                rpvot = rpvot.replace(/\,/g,'.');
                rpvot = parseFloat(rpvot)
              } 
              let barniz=''     
              if(campos[73]==null || campos[73]==''){
              }else{
                barniz = campos[73].replace(/\./g,'');
                barniz = barniz.replace(/\,/g,'.');
                barniz = parseFloat(barniz)
              } 
              let demulsibilidadA=''     
              if(campos[74]==null || campos[74]==''){
              }else{
                demulsibilidadA = campos[74].replace(/\./g,'');
                demulsibilidadA = demulsibilidadA.replace(/\,/g,'.');
                demulsibilidadA = parseFloat(demulsibilidadA)
              } 
              let demulsibilidadAg=''     
              if(campos[75]==null || campos[75]==''){
              }else{
                demulsibilidadAg = campos[75].replace(/\./g,'');
                demulsibilidadAg = demulsibilidadAg.replace(/\,/g,'.');
                demulsibilidadAg = parseFloat(demulsibilidadAg)
              } 
              let demulsibilidadE=''     
              if(campos[76]==null || campos[76]==''){
              }else{
                demulsibilidadE = campos[76].replace(/\./g,'');
                demulsibilidadE = demulsibilidadE.replace(/\,/g,'.');
                demulsibilidadE = parseFloat(demulsibilidadE)
              } 
              let demulsibilidadT=''     
              if(campos[77]==null || campos[77]==''){
              }else{
                demulsibilidadT = campos[77].replace(/\./g,'');
                demulsibilidadT = demulsibilidadT.replace(/\,/g,'.');
                demulsibilidadT = parseFloat(demulsibilidadT)
              } 
              let espumas1_0=''     
              if(campos[78]==null || campos[78]==''){
              }else{
                espumas1_0 = campos[78].replace(/\./g,'');
                espumas1_0 = espumas1_0.replace(/\,/g,'.');
                espumas1_0 = parseFloat(espumas1_0)
              } 
              let espumas1_10=''     
              if(campos[79]==null || campos[79]==''){
              }else{
                espumas1_10 = campos[79].replace(/\./g,'');
                espumas1_10 = espumas1_10.replace(/\,/g,'.');
                espumas1_10 = parseFloat(espumas1_10)
              }  
              let espumas2_0=''     
              if(campos[80]==null || campos[80]==''){
              }else{
                espumas2_0 = campos[80].replace(/\./g,'');
                espumas2_0 = espumas2_0.replace(/\,/g,'.');
                espumas2_0 = parseFloat(espumas2_0)
              }  
              let espumas2_10=''     
              if(campos[81]==null || campos[81]==''){
              }else{
                espumas2_10 = campos[81].replace(/\./g,'');
                espumas2_10 = espumas2_10.replace(/\,/g,'.');
                espumas2_10 = parseFloat(espumas2_10)
              } 
              let espumas3_0=''     
              if(campos[82]==null || campos[82]==''){
              }else{
                espumas3_0 = campos[82].replace(/\./g,'');
                espumas3_0 = espumas3_0.replace(/\,/g,'.');
                espumas3_0 = parseFloat(espumas3_0)
              } 
              let espumas3_10=''     
              if(campos[83]==null || campos[83]==''){
              }else{
                espumas3_10 = campos[83].replace(/\./g,'');
                espumas3_10 = espumas3_10.replace(/\,/g,'.');
                espumas3_10 = parseFloat(espumas3_10)
              } 
              let liberacion=''     
              if(campos[84]==null || campos[84]==''){
              }else{
                liberacion = campos[84].replace(/\./g,'');
                liberacion = liberacion.replace(/\,/g,'.');
                liberacion = parseFloat(liberacion)
              } 
              let inflamacion=''     
              if(campos[85]==null || campos[85]==''){
              }else{
                inflamacion = campos[85].replace(/\./g,'');
                inflamacion = inflamacion.replace(/\,/g,'.');
                inflamacion = parseFloat(inflamacion)
              } 
              let corrosion=''     
              if(campos[86]==null || campos[86]==''){
              }else{
                corrosion = campos[86].replace(/\./g,'');
                corrosion = corrosion.replace(/\,/g,'.');
              } 
              let ultracentrifuga=''     
              if(campos[87]==null || campos[87]==''){
              }else{
                ultracentrifuga = campos[87].replace(/\./g,'');
                ultracentrifuga = ultracentrifuga.replace(/\,/g,'.');
              } 
              let densidad=''     
              if(campos[88]==null || campos[88]==''){
              }else{
                densidad = campos[88].replace(/\./g,'');
                densidad = densidad.replace(/\,/g,'.');
              }
              let apariencia=''     
              if(campos[89]==null || campos[89]==''){
              }else{
                apariencia = campos[89].replace(/\./g,'');
                apariencia = apariencia.replace(/\,/g,'.');
              }
              let olor=''     
              if(campos[90]==null || campos[90]==''){
              }else{
                olor = campos[90].replace(/\./g,'');
                olor = olor.replace(/\,/g,'.');
              }
              let fuego=''     
              if(campos[91]==null || campos[91]==''){
              }else{
                fuego = campos[91].replace(/\./g,'');
                fuego = fuego.replace(/\,/g,'.');
              }
              let pq=''            
              if(campos[92]==null || campos[92]==''){
              }else{
                pq = campos[92].replace(/\./g,'');
                pq = pq.replace(/\,/g,'.');
                pq = parseFloat(pq)
              }                        
              let fischer=''            
              if(campos[93]==null || campos[93]==''){
              }else{
                fischer = campos[93].replace(/\./g,'');
                fischer = fischer.replace(/\,/g,'.');
                fischer = parseFloat(fischer)
              }                      
              let tanpte=''            
              if(campos[94]==null || campos[94]==''){
              }else{
                tanpte = campos[94].replace(/\./g,'');
                tanpte = tanpte.replace(/\,/g,'.');
                tanpte = parseFloat(tanpte)
              }                
              let tbnpte=''            
              if(campos[95]==null || campos[95]==''){
              }else{
                tbnpte = campos[95].replace(/\./g,'');
                tbnpte = tbnpte.replace(/\,/g,'.');
                tbnpte = parseFloat(tbnpte)
              }
              let separaA54=''     
              if(campos[96]==null || campos[96]==''){
              }else{
                separaA54 = campos[96].replace(/\./g,'');
                separaA54 = separaA54.replace(/\,/g,'.');
                separaA54 = parseFloat(separaA54)
              } 
              let separaAg54=''     
              if(campos[97]==null || campos[97]==''){
              }else{
                separaAg54 = campos[97].replace(/\./g,'');
                separaAg54 = separaAg54.replace(/\,/g,'.');
                separaAg54 = parseFloat(separaAg54)
              } 
              let separaE54=''     
              if(campos[98]==null || campos[98]==''){
              }else{
                separaE54 = campos[98].replace(/\./g,'');
                separaE54 = separaE54.replace(/\,/g,'.');
                separaE54 = parseFloat(separaE54)
              } 
              let separaT54=''     
              if(campos[99]==null || campos[99]==''){
              }else{
                separaT54 = campos[99].replace(/\./g,'');
                separaT54 = separaT54.replace(/\,/g,'.');
                separaT54 = parseFloat(separaT54)
              } 
              let separaA82=''     
              if(campos[100]==null || campos[100]==''){
              }else{
                separaA82 = campos[100].replace(/\./g,'');
                separaA82 = separaA82.replace(/\,/g,'.');
                separaA82 = parseFloat(separaA82)
              } 
              let separaAg82=''     
              if(campos[101]==null || campos[101]==''){
              }else{
                separaAg82 = campos[101].replace(/\./g,'');
                separaAg82 = separaAg82.replace(/\,/g,'.');
                separaAg82 = parseFloat(separaAg82)
              } 
              let separaE82=''     
              if(campos[102]==null || campos[102]==''){
              }else{
                separaE82 = campos[102].replace(/\./g,'');
                separaE82 = separaE82.replace(/\,/g,'.');
                separaE82 = parseFloat(separaE82)
              } 
              let separaT82=''     
              if(campos[103]==null || campos[103]==''){
              }else{
                separaT82 = campos[103].replace(/\./g,'');
                separaT82 = separaT82.replace(/\,/g,'.');
                separaT82 = parseFloat(separaT82)
              } 
              let prioridad=''            
              if(campos[104]==null || campos[104]==''){
              }else{
                prioridad = campos[104].replace(/^\s+|\s+$/g, '')
              }
              let observaciones=''   
              if(!campos[105] || campos[105]===null || campos[105]==='' || campos[105]==='*' || campos[105]==='* ' || campos[105]==='\n'){
              }else{
                let parrafo = campos[105].split("*")
                parrafo.forEach((texto, ii) => {   
                  if(texto&&texto!==' '&&texto!=='  '&&texto!=='* '&&texto!=='*'){
                    if(ii===0){
                      observaciones += "* " + texto.trim()
                    }else{
                      observaciones += "\n" + "* " + texto.trim()
                    }
                  }
                })
              }                   
              let acciones='' 
              if(!campos[106] || campos[106].length<4 || campos[106]===null || campos[106]==='' || campos[106]==='  ' || campos[106]===' ' || campos[106]==='*' || campos[106]==='* ' || campos[106]==='\n' || campos[106]==='\n*' || campos[106]==='\n* '){
              }else{
                let parrafo = campos[106].split("*")
                let numReg = 0
                parrafo.forEach((texto, ii) => {   
                  if(texto&&texto!==''&&texto!==' '&&texto!=='  '&&texto!=='  '&&texto!=='* '&&texto!=='*'&&texto.length>3){
                    if(numReg===0){
                      acciones += "* " + texto.trim()
                      numReg+=1
                    }else{
                      acciones += "\n" + "* " + texto.trim()
                      numReg+=1
                    }
                  }
                })
                if(!acciones || acciones===null || acciones==='' || acciones==='*' || acciones==='* ' || acciones==='\n' || acciones==='\n*'){
                  acciones=''
                }
              }                   
              let observacionesLab=''   
              if(!campos[107] || campos[107]===null || campos[107]==='' || campos[107]==='*' || campos[107]==='* ' || campos[107]==='\n'){
              }else{
                let parrafo = campos[107].split("*")
                parrafo.forEach((texto, ii) => {   
                  if(texto&&texto!==' '&&texto!=='  '&&texto!=='* '&&texto!=='*'){
                    if(ii===0){
                      observacionesLab += "* " + texto.trim()
                    }else{
                      observacionesLab += "\n" + "* " + texto.trim()
                    }
                  }
                })
              }
              listDocum.push({mecInflab, ruta, numeroOrden, ordenSAP, numOrdenCompra, descrEmpresa, descrPlanta, descrSeccion, descrEquipo, codEquipo,
                descrComponente, descrMecanismo, descrAplicacion, estado, descrFabricante, descrLubricante, tipoGrado,
                fechaMuestra, tomaMuestra, ultimoCambio, recorrido, tipoFrecuencia, cambioFiltroAc, cambioFiltroAire, aceiteRep, 
                aceiteTotal, abrevUnidad, visco40, visco100, indice, agua, codigoPar, micras4, micras6, 
                micras14, micras21, micras25, micras38, micras70, hollin, nitracion, sulfatacion, dilucion, glicol, 
                oxidacion, tan, tbn, hierro, cobre, aluminio, cromo, plomo, estano, niquel, vanadio, titanio, 
                silicio, sodio, potasio, boro, magnesio, calcio, fosforo, zinc, molibdeno, bario, manganeso, 
                color, rulerP, rulerA, rulerF, rulerZ, rpvot, barniz, demulsibilidadA, demulsibilidadAg, demulsibilidadE, 
                demulsibilidadT, espumas1_0, espumas1_10, espumas2_0, espumas2_10, espumas3_0, espumas3_10, liberacion, inflamacion, 
                corrosion, ultracentrifuga, densidad, apariencia, olor, fuego, pq, fischer, tanpte, tbnpte, 
                separaA54, separaAg54, separaE54, separaT54, separaA82, separaAg82, separaE82, separaT82, 
                prioridad, observaciones, acciones, observacionesLab})
            }
            numDoc += 1
          })
          console.log(listDocum)

          listDocum = _.orderBy(listDocum, ['descrEmpresa', 'descrPlanta', 'descrSeccion', 'descrEquipo',
            'descrComponente', 'descrMecanismo', 'descrMetodo', 'descrTarea'], ['asc', 'asc', 'asc', 'asc', 'asc',
            'asc', 'asc', 'asc'])
          updState(listDocum)
        };
        reader.readAsBinaryString(fileInput.files[0]);
        this.setState({checked: checkTieneEncab})
        document.body.style.cursor = 'default'
      }else{
        this.setState({listDocum: [], errors: []})
      }
    }
  }

  handleSubmit = async (ev, listDocum, list)=>{
    console.log(listDocum)
    let errors = []
    if(listDocum.length===0){
      errors.push({path: "Cargue", message: "No hay información para cargar"});
    }else{
      const mecInflab = list.findIndex( inflab => parseInt(inflab.mecInflab, 10) === parseInt(listDocum[0].mecInflab, 10) );
      console.log(mecInflab, listDocum[0].mecInflab)
      if(mecInflab===-1){
        errors.push({path: "Cargue", message: `El archivo a cargar no corresponde al informe ${this.state.argsDocum.numeroInflab}`});
      }
    }
    this.setState({errors})

    for(let i=0; i<listDocum.length; i++){
      document.body.style.cursor = 'wait'

      let tipoFrecuencia = listDocum[i].tipoFrecuencia
      let fechaMuestra = listDocum[i].fechaMuestra
      let tomaMuestra = ''
      let ultimoCambio = ''
      let tomaMuestraNum = ''
      let ultimoCambioNum = ''
      let sepFecha = ''
      // console.log(fechaMuestra, tomaMuestra, listDocum[i].tomaMuestra, listDocum[i].mecInflab)
      if(!fechaMuestra){
        errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la fecha de muestra`});
      }else{
        if(fechaMuestra.substring(4, 5)!=='-' && fechaMuestra.substring(7, 8)!=='-'){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de fecha de muestra debe ser una fecha del formato aaaa-mm-dd`});
        }else{
          if(fechaMuestra.length!==10){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de fecha de muestra debe ser una fecha del formato aaaa-mm-dd`});
          }else{
            if(parseInt(fechaMuestra.substring(0, 4)) < 2000){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de fecha de muestra contiene un año no valido`});
            }
            if(parseInt(fechaMuestra.substring(5, 7)) > 12){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de fecha de muestra contiene un mes no valido`});
            }
            if((parseInt(fechaMuestra.substring(5, 7))===1 || parseInt(fechaMuestra.substring(5, 7))===3 || parseInt(fechaMuestra.substring(5, 7))===5 || parseInt(fechaMuestra.substring(5, 7))===7 || parseInt(fechaMuestra.substring(5, 7))===8 || parseInt(fechaMuestra.substring(5, 7))===10 || parseInt(fechaMuestra.substring(5, 7))===12) && parseInt(fechaMuestra.substring(8, 10)) > 31){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de fecha de muestra contiene un día no valido`});
            }
            if((parseInt(fechaMuestra.substring(5, 7))===4 || parseInt(fechaMuestra.substring(5, 7))===6 || parseInt(fechaMuestra.substring(5, 7))===9 || parseInt(fechaMuestra.substring(5, 7))===11) && parseInt(fechaMuestra.substring(8, 10)) > 30){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de fecha de muestra contiene un día no valido`});
            }            
            if((parseInt(fechaMuestra.substring(5, 7))===2) && parseInt(fechaMuestra.substring(8, 10)) > 29){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de fecha de muestra contiene un día no valido`});
            } 
          }
        }
      }
      
      if(tipoFrecuencia==='Calendario'){
        tomaMuestra = listDocum[i].tomaMuestra
        if(!tomaMuestra){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la toma de muestra o del último cambio`});
        }else{
          if(tomaMuestra.substring(4, 5)!=='-' && tomaMuestra.substring(7, 8)!=='-'){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de toma de muestra debe ser una fecha del formato aaaa-mm-dd`});
          }else{
            if(tomaMuestra.length!==10){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de toma de muestra debe ser una fecha del formato aaaa-mm-dd`});
            }else{
              if(parseInt(tomaMuestra.substring(0, 4)) < 2000){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de toma de muestra contiene un año no valido`});
              }
              if(parseInt(tomaMuestra.substring(5, 7)) > 12){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de toma de muestra contiene un mes no valido`});
              }
              if((parseInt(tomaMuestra.substring(5, 7))===1 || parseInt(tomaMuestra.substring(5, 7))===3 || parseInt(tomaMuestra.substring(5, 7))===5 || parseInt(tomaMuestra.substring(5, 7))===7 || parseInt(tomaMuestra.substring(5, 7))===8 || parseInt(tomaMuestra.substring(5, 7))===10 || parseInt(tomaMuestra.substring(5, 7))===12) && parseInt(tomaMuestra.substring(8, 10)) > 31){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de toma de muestra contiene un día no valido`});
              }
              if((parseInt(tomaMuestra.substring(5, 7))===4 || parseInt(tomaMuestra.substring(5, 7))===6 || parseInt(tomaMuestra.substring(5, 7))===9 || parseInt(tomaMuestra.substring(5, 7))===11) && parseInt(tomaMuestra.substring(8, 10)) > 30){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de toma de muestra contiene un día no valido`});
              }            
              if((parseInt(tomaMuestra.substring(5, 7))===2) && parseInt(tomaMuestra.substring(8, 10)) > 29){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de toma de muestra contiene un día no valido`});
              } 
            }
          }
        }
      }else{
        if(tipoFrecuencia==='Horas' || tipoFrecuencia==='Km'){
          tomaMuestraNum = parseInt(listDocum[i].tomaMuestra)
          if(tomaMuestraNum===null || tomaMuestraNum===''){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la toma de muestra`});
          }
          if (!/^([0-9])*$/.test(tomaMuestra)){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato de toma de muestra debe ser un número`});
          }
        }else{
          errors.push({path: "Cargue", message: `Línea: ${i + 1} El tipo de frecuencia solo puede ser Calendario, Horas o Km`});
        }
      }
      
      // console.log(fechaMuestra, ultimoCambio, listDocum[i].ultimoCambio)
      if(tipoFrecuencia==='Calendario'){ 
        ultimoCambio = listDocum[i].ultimoCambio
        if(!ultimoCambio){
          errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato de la toma de muestra o del último cambio`});
        }else{
          if(ultimoCambio.substring(4, 5)!=='-' && ultimoCambio.substring(7, 8)!=='-'){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato del último cambio debe ser una fecha del formato aaaa-mm-dd`});
          }else{
            if(ultimoCambio.length!==10){
              errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato del último cambio debe ser una fecha del formato aaaa-mm-dd`});
            }else{
              if(parseInt(ultimoCambio.substring(0, 4)) < 2000){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato del último cambio contiene un año no valido`});
              }
              if(parseInt(ultimoCambio.substring(5, 7)) > 12){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato del último cambio contiene un mes no valido`});
              }
              if((parseInt(ultimoCambio.substring(5, 7))===1 || parseInt(ultimoCambio.substring(5, 7))===3 || parseInt(ultimoCambio.substring(5, 7))===5 || parseInt(ultimoCambio.substring(5, 7))===7 || parseInt(ultimoCambio.substring(5, 7))===8 || parseInt(ultimoCambio.substring(5, 7))===10 || parseInt(ultimoCambio.substring(5, 7))===12) && parseInt(ultimoCambio.substring(8, 10)) > 31){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato del último cambio contiene un día no valido`});
              }
              if((parseInt(ultimoCambio.substring(5, 7))===4 || parseInt(ultimoCambio.substring(5, 7))===6 || parseInt(ultimoCambio.substring(5, 7))===9 || parseInt(ultimoCambio.substring(5, 7))===11) && parseInt(ultimoCambio.substring(8, 10)) > 30){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato del último cambio contiene un día no valido`});
              }            
              if((parseInt(ultimoCambio.substring(5, 7))===2) && parseInt(ultimoCambio.substring(8, 10)) > 29){
                errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato del último cambio contiene un día no valido`});
              } 
            }
          }
        }
      }else{
        if(tipoFrecuencia==='Horas' || tipoFrecuencia==='Km'){
          ultimoCambioNum = parseInt(listDocum[i].ultimoCambio)
          if(ultimoCambioNum===null || ultimoCambioNum===''){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} Falta el dato del último cambio`});
          }
          if (!/^([0-9])*$/.test(ultimoCambio)){
            errors.push({path: "Cargue", message: `Línea: ${i + 1} El dato del último cambio debe ser un número`});
          }
        }else{
          errors.push({path: "Cargue", message: `Línea: ${i + 1} El tipo de frecuencia solo puede ser Calendario, Horas o Km`});
        }
      }
      document.body.style.cursor = 'default'
    }
    this.setState({errors})

    if(errors.length===0){
      document.body.style.cursor = 'wait'

      let updColecc = []
      let argsUpd = {}
      for(let i=0; i<listDocum.length; i++){
        argsUpd['mecInflab'] = listDocum[i].mecInflab
        argsUpd['tipoAct'] = 'EditarCargue'
        argsUpd['estado'] = listDocum[i].estado
        argsUpd['ordenSAP'] = listDocum[i].ordenSAP
        argsUpd['numOrdenCompra'] = listDocum[i].numOrdenCompra
        argsUpd['prioridad'] = listDocum[i].prioridad
        argsUpd['fechaMuestra'] = listDocum[i].fechaMuestra
        argsUpd['tomaMuestra'] = listDocum[i].tomaMuestra
        argsUpd['ultimoCambio'] = listDocum[i].ultimoCambio
        argsUpd['recorrido'] = listDocum[i].recorrido
        argsUpd['cambioFiltroAc'] = listDocum[i].cambioFiltroAc
        argsUpd['cambioFiltroAire'] = listDocum[i].cambioFiltroAire
        argsUpd['aceiteRep'] = listDocum[i].aceiteRep?parseFloat(listDocum[i].aceiteRep).toFixed(2):0
        argsUpd['aceiteTotal'] = listDocum[i].aceiteTotal?parseFloat(listDocum[i].aceiteTotal).toFixed(2):0
        argsUpd['visco40'] = listDocum[i].visco40
        argsUpd['visco100'] = listDocum[i].visco100
        argsUpd['indice'] = listDocum[i].indice
        argsUpd['agua'] = listDocum[i].agua
        argsUpd['codigoPar'] = listDocum[i].codigoPar
        argsUpd['micras4'] = listDocum[i].micras4
        argsUpd['micras6'] = listDocum[i].micras6
        argsUpd['micras14'] = listDocum[i].micras14
        argsUpd['micras21'] = listDocum[i].micras21
        argsUpd['micras25'] = listDocum[i].micras25
        argsUpd['micras38'] = listDocum[i].micras38
        argsUpd['micras70'] = listDocum[i].micras70
        argsUpd['hollin'] = listDocum[i].hollin
        argsUpd['nitracion'] = listDocum[i].nitracion
        argsUpd['sulfatacion'] = listDocum[i].sulfatacion
        argsUpd['dilucion'] = listDocum[i].dilucion
        argsUpd['glicol'] = listDocum[i].glicol
        argsUpd['oxidacion'] = listDocum[i].oxidacion
        argsUpd['tan'] = listDocum[i].tan
        argsUpd['tbn'] = listDocum[i].tbn
        argsUpd['hierro'] = listDocum[i].hierro
        argsUpd['cobre'] = listDocum[i].cobre
        argsUpd['aluminio'] = listDocum[i].aluminio
        argsUpd['cromo'] = listDocum[i].cromo
        argsUpd['plomo'] = listDocum[i].plomo
        argsUpd['estano'] = listDocum[i].estano
        argsUpd['niquel'] = listDocum[i].niquel
        argsUpd['vanadio'] = listDocum[i].vanadio
        argsUpd['titanio'] = listDocum[i].titanio
        argsUpd['silicio'] = listDocum[i].silicio
        argsUpd['sodio'] = listDocum[i].sodio
        argsUpd['potasio'] = listDocum[i].potasio
        argsUpd['boro'] = listDocum[i].boro
        argsUpd['magnesio'] = listDocum[i].magnesio
        argsUpd['calcio'] = listDocum[i].calcio
        argsUpd['fosforo'] = listDocum[i].fosforo
        argsUpd['zinc'] = listDocum[i].zinc
        argsUpd['molibdeno'] = listDocum[i].molibdeno
        argsUpd['bario'] = listDocum[i].bario
        argsUpd['manganeso'] = listDocum[i].manganeso
        argsUpd['color'] = listDocum[i].color
        argsUpd['rulerP'] = listDocum[i].rulerP
        argsUpd['rulerA'] = listDocum[i].rulerA
        argsUpd['rulerF'] = listDocum[i].rulerF
        argsUpd['rulerZ'] = listDocum[i].rulerZ
        argsUpd['rpvot'] = listDocum[i].rpvot
        argsUpd['barniz'] = listDocum[i].barniz
        argsUpd['demulsibilidadA'] = listDocum[i].demulsibilidadA
        argsUpd['demulsibilidadAg'] = listDocum[i].demulsibilidadAg
        argsUpd['demulsibilidadE'] = listDocum[i].demulsibilidadE
        argsUpd['demulsibilidadT'] = listDocum[i].demulsibilidadT
        argsUpd['espumas1_0'] = listDocum[i].espumas1_0
        argsUpd['espumas1_10'] = listDocum[i].espumas1_10
        argsUpd['espumas2_0'] = listDocum[i].espumas2_0
        argsUpd['espumas2_10'] = listDocum[i].espumas2_10
        argsUpd['espumas3_0'] = listDocum[i].espumas3_0
        argsUpd['espumas3_10'] = listDocum[i].espumas3_10
        argsUpd['liberacion'] = listDocum[i].liberacion
        argsUpd['inflamacion'] = listDocum[i].inflamacion
        argsUpd['corrosion'] = listDocum[i].corrosion
        argsUpd['ultracentrifuga'] = listDocum[i].ultracentrifuga
        argsUpd['densidad'] = listDocum[i].densidad
        argsUpd['apariencia'] = listDocum[i].apariencia
        argsUpd['olor'] = listDocum[i].olor
        argsUpd['fuego'] = listDocum[i].fuego
        argsUpd['pq'] = listDocum[i].pq
        argsUpd['fischer'] = listDocum[i].fischer
        argsUpd['tanpte'] = listDocum[i].tanpte
        argsUpd['tbnpte'] = listDocum[i].tbnpte
        argsUpd['separaA54'] = listDocum[i].separaA54
        argsUpd['separaAg54'] = listDocum[i].separaAg54
        argsUpd['separaE54'] = listDocum[i].separaE54
        argsUpd['separaT54'] = listDocum[i].separaT54
        argsUpd['separaA82'] = listDocum[i].separaA82
        argsUpd['separaAg82'] = listDocum[i].separaAg82
        argsUpd['separaE82'] = listDocum[i].separaE82
        argsUpd['separaT82'] = listDocum[i].separaT82
        argsUpd['observaciones'] = listDocum[i].observaciones
        argsUpd['observacionesLab'] = listDocum[i].observacionesLab
        argsUpd['acciones'] = listDocum[i].acciones

        console.log(argsUpd)
        updColecc.push(argsUpd)
        argsUpd = {}
        
        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editInflab)
        }

        argsCrud[numDocCRUD] = updColecc[i]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editInflab
console.log(argsCrud)
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)
      }
      this.props.allInflabRtes2.refetch()
      document.body.style.cursor = 'default'

      if(listDocum.length>0){
        alert("!! Carga exitosa !!")
      }

      this.setState({open: false, confirmaAct: false})
    }
  }

  handleCopiaInf = async (ev, list)=>{
    if(list.length>0){
      document.body.style.cursor = 'wait'

      let xlsString = []
      let listRtes = list
      let xlsString1 = []
      xlsString1 = ['Código informe', 'Ruta', 'OT', 'OT SAP', 'Orden de compra', 'Empresa', 'Planta', 'Sección', 'Equipo', 'Código equipo', 'Componente',
        'Mecanismo', 'Aplicación', 'Estado', 'Fabricante del aceite', 'Nombre del aceite', 'Grado', 'Fecha de muestra', 'Toma de muestra del aceite',
        'Ultimo cambio de aceite', 'Recorrido del aceite', 'Tipo de frecuencia', 'Cambio del filtro de aceite',
        'Cambio del filtro de aire', 'Volumen de aceite de reposición',
        'Volumen de cambio de aceite', 'Unidad de volumen del lubricante', 'Viscosidad, cSt a 40ºC',
        'Viscosidad, cSt a 100ºC', 'Indice de Viscosidad IV', 'Agua', 'Codigo de particulas', 'Particulas > 4 micras',
        'Particulas > 6 micras', 'Particulas > 14 micras', 'Particulas > 21 micras', 'Particulas > 25 micras',
        'Particulas > 38 micras', 'Particulas > 70 micras','Hollin', 'Nitracion', 'Sulfatacion', 
        'Dilución por Combustible', 'Glicol', 'Oxidacion', 'TAN', 'TBN', 'Hierro (Fe)', 'Cobre (Cu)', 'Aluminio (Al)',
        'Cromo (Cr)', 'Plomo (Pb)', 'Estaño (Sn)', 'Niquel (Ni)', 'Vanadio (V)', 'Titanio (Ti)', 'Silicio (Si)',
        'Sodio (Na)', 'Potasio (K)', 'Boro (B)', 'Magnesio (Mg)', 'Calcio (Ca)', 'Fosforo (P)', 'Zinc (Zn)',
        'Molibdeno (Mo)', 'Bario (Ba)', 'Manganeso (Mn)', 'Color', 'Ruler %', 'Aminas', 'Fenoles', 'ZDDP', 'RPVOT', 
        'Barnices', 'Dem. aceite', 'Dem. agua', 'Dem. emulsión', 'Dem. tiempo', 'Espumas I 0', 'Espumas I 10', 
        'Espumas II 0', 'Espumas II 10', 'Espumas III 0', 'Espumas III 10', 'Lib. aire', 'Punto inf.', 'Corrosión', 'Ultracentrifuga', 
        'Densidad a 15°C', 'Apariencia', 'Olor', 'Punto de fuego', 'Indice PQ', 'Fischer', 'TAN con PTE', 'TBN con PTE', 
        'Sep. 54 aceite', 'Sep. 54 agua', 'Sep. 54 emulsión', 'Sep. 54 tiempo', 'Sep. 82 aceite', 'Sep. 82 agua', 'Sep. 82 emulsión', 'Sep. 82 tiempo', 
        'Prioridad', 'Análisis', 'Acciones', 'Observaciones del laboratorio']
      xlsString.push(xlsString1)

      for(let i=0; i<listRtes.length; i++){
        xlsString1 = [listRtes[i].mecInflab, listRtes[i].ruta, listRtes[i].numeroOrden, listRtes[i].ordenSAP, listRtes[i].numOrdenCompra, 
        listRtes[i].descrEmpresa, listRtes[i].descrPlanta,
          listRtes[i].descrSeccion, listRtes[i].descrEquipo, listRtes[i].codEquipo, listRtes[i].descrComponente,
          listRtes[i].descrMecanismo, listRtes[i].descrAplicacion, '', listRtes[i].descrFabricante,
          listRtes[i].descrLubricante, listRtes[i].tipoGrado, listRtes[i].fechaMuestra, listRtes[i].tomaMuestra, 
          listRtes[i].ultimoCambio, listRtes[i].recorrido, listRtes[i].tipoFrecuencia, listRtes[i].cambioFiltroAc, 
          listRtes[i].cambioFiltroAire, listRtes[i].aceiteRep, listRtes[i].aceiteTotal, listRtes[i].abrevUnidad,
          listRtes[i].visco40, listRtes[i].visco100, 
          listRtes[i].indice, listRtes[i].agua, 
          listRtes[i].codigoPar, 
          listRtes[i].micras4, listRtes[i].micras6, listRtes[i].micras14, 
          listRtes[i].micras21, listRtes[i].micras25, listRtes[i].micras38, 
          listRtes[i].micras70, listRtes[i].hollin, listRtes[i].nitracion, 
          listRtes[i].sulfatacion, listRtes[i].dilucion, listRtes[i].glicol, 
          listRtes[i].oxidacion, listRtes[i].tan, listRtes[i].tbn, 
          listRtes[i].hierro, listRtes[i].cobre, listRtes[i].aluminio, 
          listRtes[i].plomo, listRtes[i].cromo, listRtes[i].estano, 
          listRtes[i].niquel, listRtes[i].vanadio, listRtes[i].titanio, 
          listRtes[i].silicio, listRtes[i].sodio, listRtes[i].potasio, 
          listRtes[i].boro, listRtes[i].magnesio, listRtes[i].calcio, 
          listRtes[i].fosforo, listRtes[i].zinc, listRtes[i].molibdeno, 
          listRtes[i].bario, listRtes[i].manganeso, listRtes[i].color, listRtes[i].rulerP, listRtes[i].rulerA, 
          listRtes[i].rulerF, listRtes[i].rulerZ, listRtes[i].rpvot, 
          listRtes[i].barniz, listRtes[i].demulsibilidadA, listRtes[i].demulsibilidadAg, 
          listRtes[i].demulsibilidadE, listRtes[i].demulsibilidadT, listRtes[i].espumas1_0, 
          listRtes[i].espumas1_10, listRtes[i].espumas2_0, listRtes[i].espumas2_10, 
          listRtes[i].espumas3_0, listRtes[i].espumas3_10, listRtes[i].liberacion, 
          listRtes[i].inflamacion, listRtes[i].corrosion, listRtes[i].ultracentrifuga, listRtes[i].densidad, 
          listRtes[i].apariencia, listRtes[i].olor, listRtes[i].fuego, 
          listRtes[i].pq?listRtes[i].pq:'', listRtes[i].fischer?listRtes[i].fischer:'', 
          listRtes[i].tanpte?listRtes[i].tanpte:'', listRtes[i].tbnpte?listRtes[i].tbnpte:'', 
          listRtes[i].separaA54, listRtes[i].separaAg54, listRtes[i].separaE54, listRtes[i].separaT54, 
          listRtes[i].separaA82, listRtes[i].separaAg82, listRtes[i].separaE82, listRtes[i].separaT82, 
          listRtes[i].prioridad, 
          listRtes[i].observaciones?listRtes[i].observaciones.replace(/\n|\r/g, ""):'', 
          listRtes[i].acciones?listRtes[i].acciones.replace(/\n|\r/g, ""):'', 
          listRtes[i].observacionesLab?listRtes[i].observacionesLab.replace(/\n|\r/g, ""):''] 

        xlsString.push(xlsString1)
      }
console.log(xlsString)

      var wb = XLSX.utils.book_new();

      wb.Props = {
        Title: "SheetJS Tutorial",
        Subject: "Test",
        Author: "Red Stapler",
        CreatedDate: new Date(2017,12,19)
      };

      wb.SheetNames.push("Inflab");

      let ws_data = xlsString;

      let ws = XLSX.utils.aoa_to_sheet(ws_data);
      wb.Sheets["Inflab"] = ws;
      let wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
      function s2ab(s) { 
        let buf = new ArrayBuffer(s.length); 
        let view = new Uint8Array(buf);  
        for (let i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; 
        return buf;    
      }
      document.body.style.cursor = 'default'

      saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), 'informe_'+this.state.argsDocum.numeroInflab+'.xlsx');
    }
    this.setState({open: false, confirmaAct: false})
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidMount(){
    if(this.props.allInflabRtes1.allInflabRtes){
      if(this.props.allInflabRtes1.allInflabRtes.length>0&&this.state.argsDocum.numeroInflab===0){
        let argsBuscar=""
        // argsBuscar += `'estadoInflab': 'GENERADO', 'numeroInflab': ${this.props.allInflabRtes1.allInflabRtes[0].numeroInflab}`
        argsBuscar += `'numeroInflab': ${this.props.allInflabRtes1.allInflabRtes[0].numeroInflab}`

        let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
        this.props.allInflabRtes2.refetch(argsBuscarIl)
        const argsDocum = this.state.argsDocum
        argsDocum.numeroInflab = this.props.allInflabRtes1.allInflabRtes[0].numeroInflab
        this.setState({argsDocum})
      }
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.allInflabRtes1.allInflabRtes){
      if(this.props.allInflabRtes1.allInflabRtes.length>0&&this.state.argsDocum.numeroInflab===0){
        let argsBuscar=""
        // argsBuscar += `'estadoInflab': 'GENERADO', 'numeroInflab': ${this.props.allInflabRtes1.allInflabRtes[0].numeroInflab}`
        argsBuscar += `'numeroInflab': ${this.props.allInflabRtes1.allInflabRtes[0].numeroInflab}`
        
        let argsBuscarIl = {tipoqry: `[{$match: {${argsBuscar}}}]`}
        this.props.allInflabRtes2.refetch(argsBuscarIl)
        const argsDocum = this.state.argsDocum
        argsDocum.numeroInflab = this.props.allInflabRtes1.allInflabRtes[0].numeroInflab
        this.setState({argsDocum})
      }
    }
  }

  render(){
    const {listDocum, checked, permiteUpdate, confirmaAct, open, errors} = this.state;

    let estilos = Object.assign({}, this.props.styles.input, {cursor: 'pointer'})

    let mensaje = "Cargar"
    let imgIcon = "images/documento_32.png"

    let list = [], list2 = []
    if(this.props.allInflabRtes2.allInflabRtes){list = this.props.allInflabRtes2.allInflabRtes}
    if(this.props.allInflabRtes1.allInflabRtes){list2 = this.props.allInflabRtes1.allInflabRtes}

    return (
      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.handleSubmit(ev, listDocum, list):()=>{}}>
          <div className="ui four column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '15%', paddingLeft: '1.2em'}}>
                <Form.Field>
                  <ListaNuminf styles={this.props.styles} list={list2} handleChange={this.handleChange} />
                </Form.Field>
              </div>
              <div className="column" style={{width: '38%', paddingRight: '0.1em'}}>
                <input id="csv" name="csv" type="file" accept=".csv" style={estilos} onChange={this.handleChange}></input>
              </div>
              <div className="column" style={{width: '17%', paddingLeft: '0.1em', paddingRight: '0.1em'}}>
                <Form.Field>
                  <p style={{color: '#302b63', fontSize: '1em', fontWeight: 'normal', margin: '0.4em 0em 0em 0em'}}>
                    <input style={{margin: '0.4em 0em 0em 0em'}} type='checkbox' id="checkTieneEncab"
                            name="checkTieneEncab" checked={checked} onChange={this.handleChange}/>
                    &nbsp;&nbsp;Encabezados en primera fila
                  </p>
                </Form.Field>
              </div>
              <div className="column" style={{width: '12%', paddingTop: '0.1em', paddingLeft: '0.1em'}}>
                <SeguroPermite mensaje={mensaje} imgIcon={imgIcon} permiteUpdate={permiteUpdate} open={open}
                    styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
              </div>
              <div className="column" style={{width: '18%', paddingTop: '0.1em'}}>
                <Button id="excel" name="excel" style={this.props.styles.confirmar} onClick={(ev)=>this.handleCopiaInf(ev, list)} fluid>
                  Copia informe
                </Button>
              </div>
            </div>
          </div>
          <hr></hr>
          <div>
            <div style={{height: '18em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inf</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Prioridad</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ruta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>OT</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>OT SAP</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Empresa</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Planta</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sección</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cód equipo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Componente</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Mecanismo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Nombre del aceite</th>
                  </tr>
                </thead>
                <ListaPl list={list}/>
              </table>
              <p></p>
            </div>
          </div>
          <hr></hr>
          <div>
            <div style={{height: '18em', overflow: 'auto'}}>
              <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                <thead className=''>
                  <tr className=''>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inf</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estado</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha de muestra del aceite</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Toma de muestra del aceite</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ultimo cambio de aceite</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Recorrido del aceite</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cambio del filtro de aceite</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cambio del filtro de aire</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Volumen de aceite de reposición</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Volumen de cambio de aceite</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Color</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Viscosidad, cSt a 40ºC</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Viscosidad, cSt a 100ºC</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Indice de Viscosidad IV</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Agua</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Codigo de particulas</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas 4 micras</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas 6 micras</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas 14 micras</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas 21 micras</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas 25 micras</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas 38 micras</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Particulas 70 micras</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Hollin</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Nitracion</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sulfatacion</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dilución por Combustible</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Glicol</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Oxidacion</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TAN</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TBN</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Hierro (Fe)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cobre (Cu)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aluminio (Al)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cromo (Cr)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Plomo (Pb)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Estaño (Sn)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Niquel (Ni)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Vanadio (V)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Titanio (Ti)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Silicio (Si)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sodio (Na)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Potasio (K)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Boro (B)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Magnesio (Mg)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Calcio (Ca)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fosforo (P)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Zinc (Zn)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Molibdeno (Mo)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Bario (Ba)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Manganeso (Mn)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Color</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ruler %</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Aminas</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fenoles</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>ZDDP</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>RPVOT (Sn)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Barniz (Ni)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dem. aceite (V)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dem. agua</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dem. emulsión</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Dem. tiempo</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. aceite a 54 (V)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. agua a 54</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. emulsión a 54</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. tiempo a 54</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. aceite a 82 (V)</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. agua a 82</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. emulsión a 82</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Sep. tiempo a 82</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas I 0</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas I 10</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas II 0</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas II 10</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas III 0</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Espumas III 10</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Liberación</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inflamación</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Corrosión</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Ultracentrifuga</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Densidad a 15°C</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Apariencia</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Olor</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Punto de fuego</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Indice PQ</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Agua con Karl Fischer</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TAN con PTE</th>
                    <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>TBN con PTE</th>
                  </tr>
                </thead>
                <ListaPlDet list={list}/>
              </table>
              <p></p>
            </div>
          </div>
          
          {
            errors.length?<Message negative header="Los siguientes errores:"
            list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
          }

        </Form>
      </div>
    )
  }
};

export default compose(
  // graphql(queries.query.allInflabRtes, {name:'allInflabRtes2',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': 'GENERADO', 'numeroInflab': 0}}]`}}}}),

  graphql(queries.query.allInflabRtes, {name:'allInflabRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': 'GENERADO'}}, 
      {$group: {_id: '$numeroInflab'}}, {$sort: {_id: -1}}, {$project: {'numeroInflab': '$_id'}}]`}}}}),
  
      graphql(queries.query.allInflabRtes, {name:'allInflabRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'numeroInflab': 0}}]`}}}}),
  
  // graphql(queries.query.allInflabRtes, {name:'allInflabRtes1',
  //   options: (props) => {return {variables: {tipoqry: `[{$group: {_id: '$numeroInflab'}}, {$sort: {_id: -1}}, {$project: {'numeroInflab': '$_id'}}]`}}}}),
  
  graphql(queries.query.allInflabRtes, {name:'allInflabRtes3',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'estadoInflab': 'FINALIZADO', 'numeroInflab': 0}}]`}}}}),

  graphql(queries.mutation.editInflab, {name:'editInflab'}),

  graphql(queries.mutation.fecha, {name:'fecha'})
)(LabCargares2)
